import React, { useState, useEffect, useRef, useCallback } from "react";
import { FormattedMessage } from "react-intl";
import copy from "copy-to-clipboard";
import cn from "classnames";

import Label from "../Label";
import Validation from "../Validation";
import { Copied } from "../shared-style";

import { StyledFormElement, StyledInputTextArea } from "./styles";
import messages from "./messages";
import { IProps } from "./interfaces";

const InputTextArea = ({
    label,
    value,
    onChange,
    maxLength,
    disabled,
    required,
    validation,
    messageLength,
    name,
    nowrap,
    height,
    code,
    onBlur,
    onFocus,
    rows,
    placeholder,
    selectAllOnMount,
    focusOnMount,
    selectAllOnClick,
    copyOnClick,
}: IProps) => {
    const [copied, setCopied] = useState(false);
    const inputRef = useRef<HTMLTextAreaElement>(null);
    const timerRef = useRef<ReturnType<typeof setTimeout>>();
    const onClick = useCallback(() => {
        if (selectAllOnClick) {
            inputRef!.current!.focus();
            inputRef!.current!.setSelectionRange(0, value.length);
        }
        if (copyOnClick) {
            copy(value);
            setCopied(true);
            timerRef!.current = setTimeout(() => {
                setCopied(false);
            }, 2500);
        }
    }, []);
    useEffect(() => {
        if (selectAllOnMount) {
            inputRef!.current!.focus();
            inputRef!.current!.setSelectionRange(0, value.length);
        } else if (focusOnMount) {
            inputRef!.current!.focus();
        }
        return () => {
            clearTimeout(timerRef!.current!);
        }
    }, []);

    return (
        <StyledFormElement>
            <Label disabled={disabled} required={required}>
                {label}
                {copied && (
                    <Copied>
                        <FormattedMessage {...messages.copied} />
                    </Copied>
                )}
            </Label>
            {validation && <Validation validation={validation} messageLength={messageLength} />}
            <StyledInputTextArea
                name={name}
                rows={rows}
                className={cn(validation && "ValidationState", nowrap && "NoWrap", code && "Code")}
                value={value}
                onChange={onChange}
                maxLength={maxLength}
                style={{ height }}
                ref={inputRef}
                disabled={disabled}
                onClick={onClick}
                onBlur={onBlur}
                placeholder={placeholder}
                onFocus={onFocus}
            />
        </StyledFormElement>
    );
}

export default InputTextArea;
